import { render, staticRenderFns } from "./groupG.vue?vue&type=template&id=6fc5dcee&scoped=true"
import script from "./groupG.vue?vue&type=script&lang=js"
export * from "./groupG.vue?vue&type=script&lang=js"
import style0 from "./groupG.vue?vue&type=style&index=0&id=6fc5dcee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc5dcee",
  null
  
)

export default component.exports